/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */
import "./styled.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  bottomBar: "_1pfhpxbi"
};
var truncateStyles = null;
var outerStyles = null;
var titleStyles = null;
var titleWrapperStyles = null;
var titleWrapperTruncateStyles = null;
var titleContainerStyles = null;
var actionStyles = null;
var titleContainerTruncateStyles = null;

/**
 * __Outer wrapper__.
 *
 * An outer wrapper that is the outermost component of the PageHeader component. It wraps around the PageHeader, its Actions,
 * the BottomBar and its Breadcrumbs.
 *
 */
export var OuterWrapper = function OuterWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"])
  }, children);
};
/**
 * __Styled title wrapper__.
 *
 * A styled title wrapper is a wrapper around the title that controls its the styles exclusively.
 *
 */
export var StyledTitleWrapper = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    id = _ref2.id,
    truncateTitle = _ref2.truncateTitle,
    testId = _ref2.testId;
  return /*#__PURE__*/React.createElement("h1", {
    ref: ref,
    tabIndex: -1,
    id: id,
    "data-testid": testId && "".concat(testId, "--title"),
    className: ax(["_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf", truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"])
  }, children);
});
/**
 * __Title wrapper__.
 *
 * A title wrapper is a wrapper around the title and the actions.
 *
 */
export var TitleWrapper = function TitleWrapper(_ref3) {
  var children = _ref3.children,
    truncateTitle = _ref3.truncateTitle;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _4cvr1y6m _1n261q9c", truncateTitle && "_1n261q9c"])
  }, children);
};

/**
 * Title container.
 *
 * A title container is a container that wraps around the title and its styles (if applied).
 *
 */
export var TitleContainer = function TitleContainer(_ref4) {
  var children = _ref4.children,
    truncateTitle = _ref4.truncateTitle;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc _1i4q1hna", truncateTitle && "_1o9zkb7n"])
  }, children);
};

/**
 * __Actions wrapper__.
 *
 * An actions wrapper is a wrapper for the actions, which appear on the top right of the PageHeader component.
 *
 */
export var ActionsWrapper = function ActionsWrapper(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"])
  }, children);
};

/**
 * __Bottom bar wrapper__.
 *
 * A bottom bar wrapper is a wrapper for the bottom bar, which appears at the bottom of the PageHeader component.
 *
 */
export var BottomBarWrapper = function BottomBarWrapper(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.bottomBar
  }, children);
};